// @flow

import React from "react";

type Props = {
    id: string,
};

const Anchor = ({id}: Props): React$Element<"a"> => <a className="anchor" id={id} />;

export default Anchor;
